"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _range = _interopRequireDefault(require("lodash-es/range"));

var _utils = require("../lib/utils");

require("./spinner.css");

var Spinner = function Spinner(props) {
  var _context;

  var dataTestId = props.dataTestId,
      size = props.size;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-spinner", "oui-spinner-".concat(size))
  }, (0, _map["default"])(_context = (0, _range["default"])(16)).call(_context, function (val) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: val
    });
  }));
};

Spinner.propTypes = {
  size: _propTypes["default"].oneOf(["sm", "md", "lg"]),
  dataTestId: _propTypes["default"].string
};
Spinner.defaultProps = {
  size: "md",
  dataTestId: "orion-spinner"
};
Spinner.displayName = "OrionSpinner";
var _default = Spinner;
exports["default"] = _default;